// The timeline XML an editor uploads with every version of a film (backend app/edit_xml.py): how each editing program
// makes it, and which files may be one. Final Cut saves an .fcpxmld package, a folder a browser cannot upload, so the
// editor compresses it to a .zip first.
export const XML_HOW = [
  ['Premiere', 'select the finished sequence, then File > Export > Final Cut Pro XML'],
  ['Resolve', 'select the finished timeline, then File > Export > Timeline > FCP 7 XML'],
  ['Final Cut', 'select the project, then File > Export XML; right-click the saved file, choose Compress, and upload the .zip'],
];

export const XML_ACCEPT = '.xml,.fcpxml,.zip';

export function isTimelineXmlName(name) {
  return /\.(xml|fcpxml|zip)$/i.test(name || '');
}
